import React from 'react';
import PropTypes from 'prop-types';
import {Message} from '@aperza/ui';
import ReactTooltip from 'react-tooltip';

import {CurrencyUtil} from '@aperza/util';

import { faWeightHanging, faShoppingBag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class SellerShippingTooltip extends React.Component {

  static propTypes = {
    shippingInfo: PropTypes.object.isRequired,
    shippingType: PropTypes.string.isRequired
  }

  render() {

    function SellerShippingTooltipWeight(props){
      if(props.shippingInfo.additionalShippingFeesWeight && props.shippingInfo.additionalShippingFeesWeight.length > 0){
        return (
          <span>
            <span className="col-tooltips"
              style={{float: 'right', marginLeft: '10px'}}
              data-tip={JSON.stringify(props.shippingInfo.additionalShippingFeesWeight)}
              data-for={"additionalWeight_"+props.shippingInfo.locationCode}>{<FontAwesomeIcon icon={faWeightHanging} />}
            </span>
            <ReactTooltip
              id={"additionalWeight_"+props.shippingInfo.locationCode}
              className="cell-tooltip"
              place="right"
              type="info"
              getContent={(weights) => {
                let parsedWeights = JSON.parse(weights);
                if(parsedWeights){
                  return parsedWeights.map((weight, index) => {
                    return (
                      <div key={"w_"+index} className="list-item-tooltip">
                        <ul>
                          <li><Message messageId="seller.shippingFee.referenceWeight" /> : {weight.referenceWeight}</li>
                          <li><Message messageId="seller.shippingFee.shippingFeePerAdditionalKilo" />: {CurrencyUtil.parseCurrency(weight.shippingFeePerAdditionalKilo)}</li>
                          <li><Message messageId="seller.shippingFee.shippingFee" /> : {(weight.shippingFee!=0)?CurrencyUtil.parseCurrency(weight.shippingFee, true):<Message messageId="seller.shippingFee.free" />}</li>
                        </ul>
                      </div>
                    );
                  });
                }
              }} />
          </span>
        )
      } else {
        return (null);
      }
    }

    function SellerShippingTooltipQuantity(props){
      if(props.shippingInfo.additionalShippingFeesQuantity && props.shippingInfo.additionalShippingFeesQuantity.length > 0){
        return (
          <span>
            <span className="col-tooltips"
              style={{float: 'right', marginLeft: '10px'}}
              data-tip={JSON.stringify(props.shippingInfo.additionalShippingFeesQuantity)}
              data-for={"additionalQuantity_"+props.shippingInfo.locationCode}>{<FontAwesomeIcon icon={faShoppingBag} />}
            </span>
            <ReactTooltip
              id={"additionalQuantity_"+props.shippingInfo.locationCode}
              className="cell-tooltip"
              place="right"
              type="info"
              getContent={(quantities) => {
                let parsedQuantities = JSON.parse(quantities);
                if(parsedQuantities){
                  return parsedQuantities.map((quantity, index) => {
                    return (
                      <div key={"q_"+index} className="list-item-tooltip">
                        <ul>
                          <li><Message messageId="seller.shippingFee.shippingFeePerAdditionalQuantity" /> : {CurrencyUtil.parseCurrency(quantity.shippingFeePerAdditionalQuantity)}</li>
                          <li><Message messageId="seller.shippingFee.shippingFee" /> : {(quantity.shippingFee!=0)?CurrencyUtil.parseCurrency(quantity.shippingFee, true):<Message messageId="seller.shippingFee.free" />}</li>
                        </ul>
                      </div>
                    );
                  });
                }
              }} />
          </span>
        )
      } else {
        return (null);
      }
    }

    return (
      this.props.shippingType == "weight"
        ? <SellerShippingTooltipWeight {...this.props}/>  : <SellerShippingTooltipQuantity {...this.props} />
    )
  }
}
